module.exports = __webpack_public_path__ + "assets/img/empty.d27751a1.png";